module.exports = __webpack_public_path__ + "media/assets/img/video/upload-img.svg-dee04be3fe8cadc7448dd83a12a12e21.svg";